import "./Card.scss";

import cx from "classnames";
import type { ButtonIconProps } from "components/ButtonIcon/ButtonIcon.tsx";
import ButtonIcon from "components/ButtonIcon/ButtonIcon.tsx";
import React from "react";

type TypeOptions = "form" | "full-width" | "inverse";
// @ts-expect-error we want the circular type dependency
type Type = TypeOptions | `${TypeOptions} ${Type}`;

export type HeaderButtonType = {
  hasButton: boolean;
} & Partial<ButtonIconProps>;

export type CardProps = {
  heading: React.ReactNode | string;
  cardNumber?: number;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  type?: Type;
  headerButton?: HeaderButtonType | React.ReactNode;
  classNames?: string;
};

const Card = ({
  heading,
  cardNumber,
  children,
  headerButton,
  type = "form",
  classNames,
  ...rest
}: CardProps) => {
  return (
    <div
      className={cx(
        `card card-${cardNumber} ${type}`,
        {
          "card--no-children": !children,
        },
        classNames,
      )}
      {...rest}
    >
      <div
        className={cx(
          "card__header",
          !children && "card__header__no__children",
        )}
      >
        {heading}
        {headerButton &&
          (typeof headerButton === "object" && "hasButton" in headerButton ? (
            <ButtonIcon {...(headerButton as ButtonIconProps)} />
          ) : (
            headerButton
          ))}
      </div>
      {children && <div className="card__children">{children}</div>}
    </div>
  );
};

Card.displayName = "Card";

export default Card;
